import { Component, inject, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LoadingService } from '@services/loading.service';
import { FormAlert } from '../alert/alert.component';
import { MessageService } from 'primeng/api';
import { Observable, forkJoin, map } from 'rxjs';

interface MatchFile {
  index: number;
  file: any[];
}

@Component({
  selector: 'app-form',
  imports: [],
  template: '',
})
export class FormComponent {
  protected api: ApiService = inject(ApiService);
  protected loadingService: LoadingService = inject(LoadingService);
  protected formBuilder: FormBuilder = inject(FormBuilder);
  private messageService: MessageService = inject(MessageService);

  alertData: FormAlert | null = null;
  data: any = {};
  endpoint: string = '';
  files: MatchFile[] = [];
  form: any;
  initialized = signal<boolean>(false);
  loading = signal<boolean>(false);
  loadEndpoint: string = '';
  method: string = 'post';
  services: Observable<any>[] = [];
  uploadUrl: string = 'admin/segments/upload';

  load(options?: any) {
    this.startLoading();

    this.api.call(this.loadEndpoint, 'get', this.getQueryParams()).subscribe({
      next: (response) => {
        if (response.status == 200) {
          this.onLoadSuccess(response);
        } else {
          this.onLoadError(response.message);
        }
      },
      error: (error) => {
        this.onLoadError(error);
      },
    });
  }

  onLoadSuccess(response: any): void {
    this.stopLoading();
  }

  onLoadError(error: any): void {
    this.stopLoading();
  }

  getQueryParams(): any {
    // const params: any = {};

    // const { size, ...paramsQ } = { ...this.params };

    // for (const [key, value] of Object.entries(paramsQ)) {
    //   if (value !== -1 && value !== null && value !== '') {
    //     params[key] = value;
    //   }
    // }

    // return params;
    return '';
  }

  isValid(): boolean {
    return true;
  }

  getParams() {
    return this.data;
  }

  submit() {
    if (!this.isValid()) return;

    this.alertData = null;

    this.startLoading();

    const params = this.getParams();

    this.api.call(this.endpoint, this.method, params).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.success(response);
        } else {
          this.failed(response.message.join(', '));
        }
      },
      error: (error) => {
        this.failed(error);
      },
    });
  }

  handleMedia(): Observable<string[]> {
    this.startLoading();

    const services: Observable<string>[] = [];

    this.files.forEach((fileMath) => {
      fileMath.file.forEach((file: any) => {
        if (file instanceof File) {
          const formData = new FormData();
          formData.append('image', file);

          services.push(
            this.api.call(this.uploadUrl, 'post', formData).pipe(
              map((response: any) => {
                if (response.status === 200) {
                  return response.data.path;
                } else {
                  throw new Error(response.message || 'Upload failed');
                }
              })
            )
          );
        }
      });
    });

    return forkJoin(services).pipe(
      map((paths: string[]) => {
        this.stopLoading();
        return paths;
      })
    );
  }

  handleFileMedia(media: any[], index: number) {
    const exist = this.files.findIndex((file) => {
      return file.index === index;
    });

    if (exist !== -1) {
      this.files[exist] = {
        index,
        file: media,
      };
    } else {
      this.files.push({
        index,
        file: media,
      });
    }
  }

  success(response: any) {
    this.stopLoading();
  }

  failed(error: any) {
    this.handleAlert(
      typeof error === 'string'
        ? error || 'An error occurred!'
        : 'An error occurred!'
    );

    this.stopLoading();
  }

  getServices() {
    return this.services;
  }

  loadServices() {
    const services = !this.initialized()
      ? [...this.services]
      : [...this.getServices()];

    if (this.services.length > 0) {
      this.startLoading();

      forkJoin(services).subscribe({
        next: (data) => {
          this.onLoadServicesSuccess(data);
          this.initialized.set(true);
        },
        error: (error) => {
          console.error(error);
          this.onLoadServicesError(error);
          this.initialized.set(true);
        },
      });
    }
  }

  onLoadServicesSuccess(responses: any[]): void {
    this.stopLoading();
  }

  onLoadServicesError(errors: any[]): void {
    this.stopLoading();
  }

  handleAlert(message: string, type: string = 'danger', title: string = '') {
    let toastr: any = {};

    switch (type) {
      case 'success':
        toastr = {
          severity: 'success',
          summary: title,
          detail: message,
        };

        break;

      case 'info':
        toastr = {
          severity: 'info',
          summary: title,
          detail: message,
        };

        break;

      case 'warning':
        toastr = {
          severity: 'warn',
          summary: title,
          detail: message,
        };

        break;

      case 'danger':
        toastr = {
          severity: 'error',
          summary: title,
          detail: message,
        };

        break;

      default:
        toastr = {
          severity: 'contrast',
          summary: title,
          detail: message,
        };

        break;
    }

    this.messageService.add(toastr);
  }

  startLoading() {
    this.loading.set(true);
    this.loadingService.start();
  }

  stopLoading() {
    this.loading.set(false);
    this.loadingService.stop();
  }
}
